export function FalseMethod(target: unknown): target is false {
  return false === target;
}
